export function createRef(initialValue) {
  return {
    current: initialValue
  };
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-shared/dist/esm/createRef.js
// module id = 60
// module chunks = 0